import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const DebugPage = () => {
  const [debugInfo, setDebugInfo] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDebugInfo();
  }, []);

  const loadDebugInfo = async () => {
    setLoading(true);
    try {
      // Teste 1: Status geral
      const statusRes = await axios.get(`${API}/debug/status`);
      
      // Teste 2: Verificar token
      const token = localStorage.getItem('primaza_token');
      const user = localStorage.getItem('primaza_user');
      
      // Teste 3: Tentar buscar pedidos
      let pedidosData = null;
      let pedidosError = null;
      if (token) {
        try {
          const pedidosRes = await axios.get(`${API}/pedidos`);
          pedidosData = pedidosRes.data;
        } catch (err) {
          pedidosError = err.response?.data?.detail || err.message;
        }
      }
      
      setDebugInfo({
        backend: statusRes.data,
        frontend: {
          hasToken: !!token,
          hasUser: !!user,
          user: user ? JSON.parse(user) : null,
          apiUrl: API
        },
        pedidos: {
          data: pedidosData,
          error: pedidosError
        }
      });
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-xl">Carregando informações de debug...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-red-50 p-8">
        <div className="max-w-4xl mx-auto bg-white p-6 rounded shadow">
          <h1 className="text-2xl font-bold text-red-600 mb-4">❌ Erro ao Carregar Debug</h1>
          <pre className="bg-red-100 p-4 rounded">{error}</pre>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold mb-6">🔍 Página de Debug - PRIMAZA</h1>
        
        {/* Status do Backend */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">🖥️ Backend Status</h2>
          <div className="space-y-2">
            <p><strong>Status:</strong> {debugInfo?.backend?.status}</p>
            <p><strong>Database:</strong> {debugInfo?.backend?.database}</p>
            <p><strong>Pedidos no banco:</strong> {debugInfo?.backend?.counts?.pedidos}</p>
            <p><strong>Usuários no banco:</strong> {debugInfo?.backend?.counts?.users}</p>
            <p><strong>Transportadoras no banco:</strong> {debugInfo?.backend?.counts?.transportadoras}</p>
            <p><strong>Excel configurado:</strong> {debugInfo?.backend?.config?.excel_url_configured ? '✅ Sim' : '❌ Não'}</p>
            <p><strong>Auto-refresh:</strong> {debugInfo?.backend?.config?.auto_refresh ? '✅ Ativo' : '❌ Inativo'}</p>
          </div>
        </div>

        {/* Status do Frontend */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">💻 Frontend Status</h2>
          <div className="space-y-2">
            <p><strong>API URL:</strong> {debugInfo?.frontend?.apiUrl}</p>
            <p><strong>Token salvo:</strong> {debugInfo?.frontend?.hasToken ? '✅ Sim' : '❌ Não'}</p>
            <p><strong>Usuário salvo:</strong> {debugInfo?.frontend?.hasUser ? '✅ Sim' : '❌ Não'}</p>
            {debugInfo?.frontend?.user && (
              <div className="mt-2 p-4 bg-gray-50 rounded">
                <p><strong>Username:</strong> {debugInfo.frontend.user.username}</p>
                <p><strong>Nome:</strong> {debugInfo.frontend.user.name}</p>
                <p><strong>Role:</strong> {debugInfo.frontend.user.role}</p>
              </div>
            )}
          </div>
        </div>

        {/* Dados de Pedidos */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">📦 Pedidos Retornados pela API</h2>
          {debugInfo?.pedidos?.error ? (
            <div className="bg-red-50 p-4 rounded">
              <p className="text-red-700"><strong>❌ Erro:</strong> {debugInfo.pedidos.error}</p>
            </div>
          ) : debugInfo?.pedidos?.data ? (
            <div>
              <p className="mb-4"><strong>Total de pedidos retornados:</strong> {debugInfo.pedidos.data.length}</p>
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {debugInfo.pedidos.data.map((pedido, idx) => (
                  <div key={idx} className="p-3 bg-gray-50 rounded border">
                    <p><strong>Pedido:</strong> {pedido.pedido || 'N/A'}</p>
                    <p><strong>Cliente:</strong> {pedido.nome_cliente || 'N/A'}</p>
                    <p><strong>Status:</strong> {pedido.status_pedido || 'N/A'}</p>
                    <p><strong>Vendedor:</strong> {pedido.vendedor || 'N/A'}</p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className="text-gray-500">⚠️ Nenhum dado disponível (precisa fazer login)</p>
          )}
        </div>

        {/* Ações */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">🔧 Ações</h2>
          <div className="space-x-4">
            <button
              onClick={loadDebugInfo}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              🔄 Recarregar
            </button>
            <button
              onClick={() => {
                localStorage.clear();
                window.location.href = '/';
              }}
              className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              🚪 Limpar Cache e Voltar
            </button>
            <button
              onClick={() => window.location.href = '/'}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              🏠 Voltar ao Sistema
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugPage;
